import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import LoginPage from './pages/LoginPage'
import C2App from './portals/c2/C2App'
import DAFApp from './portals/daf/DAFApp'
import AdminApp from './portals/admin/AdminApp'
import { Toaster } from 'sonner'

function LoadingScreen() {
  return (
    <div className="h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-slate-900 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-slate-500 font-medium" style={{ fontFamily: 'Inter, sans-serif' }}>
          Chargement...
        </p>
      </div>
    </div>
  )
}

function AppRoutes() {
  const { session, profile, loading } = useAuth()

  if (loading) return <LoadingScreen />
  if (!session) return <LoginPage />

  const role = profile?.role

  function RoleRedirect() {
    if (!role) return <LoadingScreen />
    if (role === 'master_admin') return <Navigate to="/c2/clients" replace />
    if (role === 'c2_admin' || role === 'c2_gestionnaire') return <Navigate to="/c2" replace />
    if (role === 'client_daf') return <Navigate to="/daf" replace />
    // Anciens déclarants redirigés vers la connexion
    return <LoginPage />
  }

  const isC2Role = ['master_admin', 'c2_admin', 'c2_gestionnaire'].includes(role)
  const isAdminRole = ['master_admin', 'c2_admin'].includes(role)

  return (
    <Routes>
      <Route path="/" element={<RoleRedirect />} />
      <Route
        path="/admin/*"
        element={isAdminRole ? <AdminApp /> : <Navigate to="/" replace />}
      />
      <Route
        path="/c2/*"
        element={isC2Role ? <C2App /> : <Navigate to="/" replace />}
      />
      <Route
        path="/daf/*"
        element={role === 'client_daf' ? <DAFApp /> : <Navigate to="/" replace />}
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  )
}
